/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './work-flow-step-log.reducer';

export const WorkFlowStepLogDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const workFlowStepLogEntity = useAppSelector(state => state.workFlowStepLog.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="workFlowStepLogDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.workFlowStepLog.detail.title">WorkFlowStepLog</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.workFlowStepLog.id">Id</Translate>
            </span>
          </dt>
          <dd>{workFlowStepLogEntity.id}</dd>
          <dt>
            <span id="value">
              <Translate contentKey="tinyMedicRestApp.workFlowStepLog.value">Value</Translate>
            </span>
            <UncontrolledTooltip target="value">
              <Translate contentKey="tinyMedicRestApp.workFlowStepLog.help.value" />
            </UncontrolledTooltip>
          </dt>
          <dd>{workFlowStepLogEntity.value}</dd>
          <dt>
            <span id="notes">
              <Translate contentKey="tinyMedicRestApp.workFlowStepLog.notes">Notes</Translate>
            </span>
            <UncontrolledTooltip target="notes">
              <Translate contentKey="tinyMedicRestApp.workFlowStepLog.help.notes" />
            </UncontrolledTooltip>
          </dt>
          <dd>{workFlowStepLogEntity.notes}</dd>
          <dt>
            <span id="completedById">
              <Translate contentKey="tinyMedicRestApp.workFlowStepLog.completedById">Completed By Id</Translate>
            </span>
            <UncontrolledTooltip target="completedById">
              <Translate contentKey="tinyMedicRestApp.workFlowStepLog.help.completedById" />
            </UncontrolledTooltip>
          </dt>
          <dd>{workFlowStepLogEntity.completedById}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.workFlowStepLog.active">Active</Translate>
            </span>
            <UncontrolledTooltip target="active">
              <Translate contentKey="tinyMedicRestApp.workFlowStepLog.help.active" />
            </UncontrolledTooltip>
          </dt>
          <dd>{workFlowStepLogEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.workFlowStepLog.cursor">Cursor</Translate>
            </span>
            <UncontrolledTooltip target="cursor">
              <Translate contentKey="tinyMedicRestApp.workFlowStepLog.help.cursor" />
            </UncontrolledTooltip>
          </dt>
          <dd>{workFlowStepLogEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.workFlowStepLog.lastUpdated">Last Updated</Translate>
            </span>
            <UncontrolledTooltip target="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.workFlowStepLog.help.lastUpdated" />
            </UncontrolledTooltip>
          </dt>
          <dd>{workFlowStepLogEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.workFlowStepLog.microSec">Micro Sec</Translate>
            </span>
            <UncontrolledTooltip target="microSec">
              <Translate contentKey="tinyMedicRestApp.workFlowStepLog.help.microSec" />
            </UncontrolledTooltip>
          </dt>
          <dd>{workFlowStepLogEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.workFlowStepLog.timestampEntry">Timestamp Entry</Translate>
            </span>
            <UncontrolledTooltip target="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.workFlowStepLog.help.timestampEntry" />
            </UncontrolledTooltip>
          </dt>
          <dd>{workFlowStepLogEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.workFlowStepLog.completedByType">Completed By Type</Translate>
          </dt>
          <dd>{workFlowStepLogEntity.completedByType ? workFlowStepLogEntity.completedByType.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.workFlowStepLog.step">Step</Translate>
          </dt>
          <dd>{workFlowStepLogEntity.step ? workFlowStepLogEntity.step.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.workFlowStepLog.protocol">Protocol</Translate>
          </dt>
          <dd>{workFlowStepLogEntity.protocol ? workFlowStepLogEntity.protocol.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/work-flow-step-log" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/work-flow-step-log/${workFlowStepLogEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default WorkFlowStepLogDetail;
